import { Box, Checkbox, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function CopAuthorityCheckbox({ item }) {
    const { selected, setSelected } = useBoundContext()
    const isChecked = selected.has(item.value)

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.25 }}>
            <Checkbox checked={isChecked} onChange={handleChange} size="small" sx={{ p: 0.5 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, color: item.color }}>
                <Iconify icon={item.icon} width={16} height={16} />
                <Typography variant="body2" color="inherit">
                    {item.label}
                </Typography>
            </Box>
        </Box>
    )

    function handleChange(e) {
        setSelected((prev) => {
            const next = new Set(prev)
            if (e.target.checked) next.add(item.value)
            else next.delete(item.value)
            return next
        })
    }
}
